<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="panel">
        <div class="panel-hdr">
          <h1 class="subheader-title">
            <i class="subheader-icon fal fa-code"></i> Документация по API
          </h1>
        </div>
        <div class="panel-container show">
          <div class="panel-content">
            <div class="row no-gutters">
              <div class="col-md-9">
                  <div data-element="content" class="position-relative overflow-auto p-2 api-content">
                      <ApiIntro :token="token" :url="url"/>
                      
                      <h2 id="api_users">Пользователи</h2>
                      
                      <ApiUsersCreate :token="token" :url="url" :user="user"/>
                      <ApiUsersRestore :token="token" :url="url" :user="user"/>
                      <ApiUsersVerify :token="token" :url="url" :user="user"/>
                      <ApiUsersLogin :token="token" :url="url" :user="user"/>
                      <ApiUsersEdit :token="token" :url="url" :user="user"/>
                      <ApiUsersPassword :token="token" :url="url" :user="user"/>
                      <ApiUsersShow :token="token" :url="url" :user="user"/>
                      
                      <h2 id="api_groups">Категории</h2>

                      <ApiGroupsCreate :token="token" :url="url" :user="user"/>
                      <ApiGroupsRemove :token="token" :url="url" :user="user"/>
                      <ApiGroupsEdit :token="token" :url="url" :user="user"/>
                      <ApiGroupsList :token="token" :url="url" :user="user"/>

                      <h2 id="api_contacts">Контакты</h2>

                      <ApiContactsCreate :token="token" :url="url" :user="user"/>
                      <ApiContactsCode :token="token" :url="url" :user="user"/>
                      <ApiContactsVerify :token="token" :url="url" :user="user"/>
                      <ApiContactsRemove :token="token" :url="url" :user="user"/>
                      <ApiContactsEdit :token="token" :url="url" :user="user"/>
                      <ApiContactsList :token="token" :url="url" :user="user"/>

                      <h2 id="api_tasks">Задачи</h2>

                      <ApiTasksCreate :token="token" :url="url" :user="user"/>
                      <ApiTasksEdit :token="token" :url="url" :user="user"/>
                      <ApiTasksRemove :token="token" :url="url" :user="user"/>
                      <ApiTasksEvents :token="token" :url="url" :user="user"/>
                      <ApiTasksShow :token="token" :url="url" :user="user"/>
                      <ApiTasksList :token="token" :url="url" :user="user"/>

                      <h2 id="api_statistics">Статистика</h2>

                      <ApiStatisticsTaskResponse :token="token" :url="url" :user="user"/>
                      <ApiStatisticsTaskUptime :token="token" :url="url" :user="user"/>
                      <ApiStatisticsSummaryUptime :token="token" :url="url" :user="user"/>
                      <ApiStatisticsSummaryTasks :token="token" :url="url" :user="user"/>

                      <!--
                      <h2 id="api_changes">Изменения</h2>

                      <ApiChanges/>
                      -->
                  </div>
              </div>
              <div class="col-md-3 hidden-md-down">
                  <div class="menu-api">
                    <h2 class="pl-4">Навигация</h2>
                    <nav id="menuApi" ref="menu" class="navbar p-2">
                        <ul class="nav api-sidenav w-100" data-element="menu">
                            <li class="nav-item">
                              <a class="nav-link" href="#api_intro"><i class="fal fa-star fa-fw mr-1"></i> Введение</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#api_users"><i class="fal fa-user-circle fa-fw mr-1"></i> Пользователи</a>
                              <ul class="nav">
                                <li><a class="nav-link" href="#api_users_create">Создание пользователя</a></li>
                                <li><a class="nav-link" href="#api_users_restore">Запрос восстановления пароля</a></li>
                                <li><a class="nav-link" href="#api_users_verify">Подтверждение восстановления пароля</a></li>
                                <li><a class="nav-link" href="#api_users_login">Авторизация</a></li>
                                <li><a class="nav-link" href="#api_users_edit">Изменение данных пользователя</a></li>
                                <li><a class="nav-link" href="#api_users_password">Изменение пароля</a></li>
                                <li><a class="nav-link" href="#api_users_show">Информация о пользователе</a></li>
                              </ul>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#api_groups"><i class="fal fa-cubes fa-fw mr-1"></i> Категории</a>
                              <ul class="nav">
                                <li><a class="nav-link" href="#api_groups_create">Создание категории</a></li>
                                <li><a class="nav-link" href="#api_groups_remove">Удаление категории</a></li>
                                <li><a class="nav-link" href="#api_groups_edit">Изменение данных категории</a></li>
                                <li><a class="nav-link" href="#api_groups_list">Список категорий</a></li>
                              </ul>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#api_contacts"><i class="fal fa-address-book fa-fw mr-1"></i> Контакты</a>
                              <ul class="nav">
                                <li><a class="nav-link" href="#api_contacts_create">Создание контакта</a></li>
                                <li><a class="nav-link" href="#api_contacts_code">Запрос кода подтверждения</a></li>
                                <li><a class="nav-link" href="#api_contacts_verify">Подтверждение контакта</a></li>
                                <li><a class="nav-link" href="#api_contacts_remove">Удаление контакта</a></li>
                                <li><a class="nav-link" href="#api_contacts_edit">Изменение данных контката</a></li>
                                <li><a class="nav-link" href="#api_contacts_list">Список контактов</a></li>
                              </ul>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#api_tasks"><i class="fal fa-clipboard-list fa-fw mr-1"></i> Задачи</a>
                              <ul class="nav">
                                <li><a class="nav-link" href="#api_tasks_create">Создание задачи</a></li>
                                <li><a class="nav-link" href="#api_tasks_edit">Изменение задачи</a></li>
                                <li><a class="nav-link" href="#api_tasks_remove">Удаление задачи</a></li>
                                <li><a class="nav-link" href="#api_tasks_events">События задачи</a></li>
                                <li><a class="nav-link" href="#api_tasks_show">Данные задачи</a></li>
                                <li><a class="nav-link" href="#api_tasks_list">Список задач</a></li>
                            </ul>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#api_statistics"><i class="fal fa-chart-pie fa-fw mr-1"></i> Статистика</a>
                              <ul class="nav">
                                <li><a class="nav-link" href="#api_statistics_task_response">Время ответа по задаче</a></li>
                                <li><a class="nav-link" href="#api_statistics_task_uptime">Время работы по задаче</a></li>
                                <li><a class="nav-link" href="#api_statistics_summary_uptime">Суммарное время работы</a></li>
                                <li><a class="nav-link" href="#api_statistics_summary_tasks">Общие данные по задачам</a></li>
                              </ul>
                            </li>
                            <!--
                            <li class="nav-item">
                              <a class="nav-link" href="#api_changes"><i class="fal fa-code-branch fa-fw mr-1"></i> Изменения</a>
                            </li>
                            -->
                        </ul>
                    </nav>
                  </div>
              </div>
          </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Введение
  import ApiIntro from '@/components/api/intro.vue';
  // Пользователи
  import ApiUsersCreate from '@/components/api/users/create.vue';
  import ApiUsersRestore from '@/components/api/users/restore.vue';
  import ApiUsersVerify from '@/components/api/users/verify.vue';
  import ApiUsersLogin from '@/components/api/users/login.vue';
  import ApiUsersEdit from '@/components/api/users/edit.vue';
  import ApiUsersPassword from '@/components/api/users/password.vue';
  import ApiUsersShow from '@/components/api/users/show.vue';
  // Категории
  import ApiGroupsCreate from '@/components/api/groups/create.vue';
  import ApiGroupsRemove from '@/components/api/groups/remove.vue';
  import ApiGroupsEdit from '@/components/api/groups/edit.vue';
  import ApiGroupsList from '@/components/api/groups/list.vue';
  // Контакты
  import ApiContactsCreate from '@/components/api/contacts/create.vue';
  import ApiContactsCode from '@/components/api/contacts/code.vue';
  import ApiContactsVerify from '@/components/api/contacts/verify.vue';
  import ApiContactsRemove from '@/components/api/contacts/remove.vue';
  import ApiContactsEdit from '@/components/api/contacts/edit.vue';
  import ApiContactsList from '@/components/api/contacts/list.vue';
  // Задачи
  import ApiTasksCreate from '@/components/api/tasks/create.vue';
  import ApiTasksEdit from '@/components/api/tasks/edit.vue';
  import ApiTasksRemove from '@/components/api/tasks/remove.vue';
  import ApiTasksEvents from '@/components/api/tasks/events.vue';
  import ApiTasksShow from '@/components/api/tasks/show.vue';
  import ApiTasksList from '@/components/api/tasks/list.vue';
  // Статистика
  import ApiStatisticsTaskResponse from '@/components/api/statistics/taskResponse.vue';
  import ApiStatisticsTaskUptime from '@/components/api/statistics/taskUptime.vue';
  import ApiStatisticsSummaryUptime from '@/components/api/statistics/summaryUptime.vue';
  import ApiStatisticsSummaryTasks from '@/components/api/statistics/summaryTasks.vue';
  // Изменения
  import ApiChanges from '@/components/api/changes.vue';

  export default {
    metaInfo: {
      title: 'Документация по API',
    },
    components: {
      // Введение
      ApiIntro,
      // Пользователи
      ApiUsersCreate,
      ApiUsersRestore,
      ApiUsersVerify,
      ApiUsersLogin,
      ApiUsersEdit,
      ApiUsersPassword,
      ApiUsersShow,
      // Категории
      ApiGroupsCreate,
      ApiGroupsRemove,
      ApiGroupsEdit,
      ApiGroupsList,
      // Контакты
      ApiContactsCreate,
      ApiContactsCode,
      ApiContactsVerify,
      ApiContactsRemove,
      ApiContactsEdit,
      ApiContactsList,
      // Задачи
      ApiTasksCreate,
      ApiTasksEdit,
      ApiTasksRemove,
      ApiTasksEvents,
      ApiTasksShow,
      ApiTasksList,
      // Статистика
      ApiStatisticsTaskResponse,
      ApiStatisticsTaskUptime,
      ApiStatisticsSummaryUptime,
      ApiStatisticsSummaryTasks,
      // Изменения
      ApiChanges
    },
    data() {
      return {
        // Адрес API
        url: process.env.VUE_APP_API_URL,
        // Ключ для работы в API
        token: localStorage.token,
        // Данные пользователя
        user: {}
      };
    },
    methods: {
      // Получение данных пользователя
      getUser () 
      {
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/users').then(response =>
        {
          this.user = response.data.data;
          this.loading = false;
        });
      },
      calculateWidthMenu() {
        $('#menuApi').css('width', $('.menu-api').width());
      }
    },
    created() {
      window.addEventListener("resize", this.calculateWidthMenu);
    },
    destroyed() {
      window.removeEventListener("resize", this.calculateWidthMenu);
    },
    mounted() {
      // Получение данных пользователя
      this.getUser();

      // Индикатор загрузки
      this.$nextTick(function () {

        // Расчет ширины меню для его закрепления
        setTimeout(function() {
            this.calculateWidthMenu();
        }.bind(this), 100);

        // Заркпление меню API
        $('#menuApi').affix({offset: 296});

        // Пометка активных элементов меню
        $('body').scrollspy({ target: '#menuApi' });
      })
    },
  }
</script>

<style>
  .affix {
    position: fixed !important;
    top: 10px;
    z-index: 9999 !important;
  }
  .api-sidenav a.active ~ .nav {
    display: block;
  }
  .api-sidenav .nav {
    display: none;
    padding-bottom: 10px;
  }
  .api-sidenav.nav > .active > ul {
    display: block;
  }
  .api-sidenav.nav {
    display: block;
  }
  .api-sidenav.nav > li {
    display: block;
  }
  body {
    position: relative;
  }
</style>